import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { get, postFormData } from "../../../helpers/api_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";

import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_GetMasterTypes,
  POST_MasterDataImportValidateInsertCustomer,
  POST_MasterDataImportValidateInsertMachinesMaster,
  POST_MasterDataImportValidateInsertMaterialGroup,
  POST_MasterDataImportValidateInsertParameters,
  POST_MasterDataImportValidateInsertReferenceStandards,
  POST_MasterDataImportValidateInsertTestMaster,
  POST_MasterDataImportValidateInsertTestMasterNonStandardParameters,
  POST_MasterDataImportValidateInsertTestMasterStandardParameters,
  POST_MasterDataImportValidateInsertTestMethods,
} from "../../../helpers/url_helper";

const MasterDataImport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [masterOptions, setMasterTypesOptions] = useState([]);

  const validationSchema = Yup.object().shape({
    MasterID: Yup.string().required("Master is required field"),
    UploadFile: Yup.string().required("File is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MasterID: "",
      MasterName: "",
      UploadFile: "",
      MasterFileFormatPath: "",
      ListOfMasterData: [],
      UploadFileKey: "",
      TotalRecords: 0,
      ValidCount: 0,
      InValidRecords: 0,
      btnSubmitType: "",
      InValidRecordsFilePath: "",
      ValidRecordsFilePath: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      MasterID,
      MasterName,
      UploadFile,
      MasterFileFormatPath,
      ListOfMasterData,
      UploadFileKey,
      TotalRecords,
      ValidCount,
      InValidRecords,
      InValidRecordsFilePath,
      ValidRecordsFilePath,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let ValidateAPIName = "";
    let formData = new FormData();

    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append("MasterDataImportFile", values?.UploadFile);
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append("ImportType", values?.btnSubmitType);

    if (MasterID == 1) {
      ValidateAPIName = POST_MasterDataImportValidateInsertCustomer; //Customer Validate Data
    } else if (MasterID == 2) {
      ValidateAPIName = ""; //Material Categories
    } else if (MasterID == 3) {
      ValidateAPIName = POST_MasterDataImportValidateInsertMaterialGroup; //Material Group
    } else if (MasterID == 4) {
      ValidateAPIName = POST_MasterDataImportValidateInsertTestMethods; //Test Method
    } else if (MasterID == 5) {
      ValidateAPIName = POST_MasterDataImportValidateInsertParameters; //Parameters
    } else if (MasterID == 6) {
      ValidateAPIName = POST_MasterDataImportValidateInsertTestMaster; //Test Master
    } else if (MasterID == 7) {
      ValidateAPIName =
        POST_MasterDataImportValidateInsertTestMasterStandardParameters; //Test Master Standard Parameter
    } else if (MasterID == 8) {
      ValidateAPIName =
        POST_MasterDataImportValidateInsertTestMasterNonStandardParameters; //Test Master Non Standard Parameter
    } else if (MasterID == 9) {
      ValidateAPIName = POST_MasterDataImportValidateInsertReferenceStandards; //Reference Standard
    } else if (MasterID == 10) {
      ValidateAPIName = ""; //Ref Standard - Test Mapping
    } else if (MasterID == 11) {
      ValidateAPIName = POST_MasterDataImportValidateInsertMachinesMaster; //Machines
    }
    //
    postFormData(ValidateAPIName, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          formik.setFieldValue("ListOfMasterData", response?.List);
          formik.setFieldValue("InValidRecords", response?.InValidRecords);
          formik.setFieldValue("ValidCount", response?.ValidCount);
          formik.setFieldValue("TotalRecords", response?.TotalRecords);
          formik.setFieldValue(
            "InValidRecordsFilePath",
            response?.InValidRecordsFilePath,
          );
          formik.setFieldValue(
            "ValidRecordsFilePath",
            response?.ValidRecordsFilePath,
          );

          if (values?.btnSubmitType == 1) {
            successMessage("File Validate....!!!");
          } else {
            successMessage("File Uploaded....!!!");
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
          formik.setFieldValue("ListOfMasterData", "");
          formik.setFieldValue("InValidRecords", 0);
          formik.setFieldValue("ValidCount", 0);
          formik.setFieldValue("TotalRecords", 0);
          formik.setFieldValue("InValidRecordsFilePath", "");
          formik.setFieldValue("ValidRecordsFilePath", "");
          formik.setFieldValue("UploadFile", "");
          formik.setFieldValue(
            "UploadFileKey",
            Math.random().toString(9).substring(2, 9),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMasterTypes();
  }, []);

  const getMasterTypes = () => {
    setIsLoading(true);
    get(POST_GetMasterTypes)
      .then((response) => {
        if (response?.IsSuccess) {
          if (
            AuthUser?.Permissions?.DT == 1 ||
            AuthUser?.Permissions?.FoodTesting == 1
          ) {
            setMasterTypesOptions(
              response?.List?.filter(
                (x) => x.MasterID !== 2 && x.MasterID !== 10,
              ).map((item) => ({
                label: item.MasterName,
                value: item.MasterID,
                MasterFileFormatPath: item.MasterFileFormatPath,
              })),
            );
          } else {
            setMasterTypesOptions(
              response?.List?.filter(
                (x) =>
                  x.MasterID !== 2 &&
                  x.MasterID !== 10 &&
                  x.MasterID !== 5 &&
                  x.MasterID !== 7 &&
                  x.MasterID !== 8 &&
                  x.MasterID !== 10,
              ).map((item) => ({
                label: item.MasterName,
                value: item.MasterID,
                MasterFileFormatPath: item.MasterFileFormatPath,
              })),
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadUploadMasterFile = (e) => {
    if (MasterID) {
      if (e.target.files[0]) {
        const file = e.target.files[0];
        const fileType = file.type;
        const validFileTypes = [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ]; // MIME types for Excel files

        if (!validFileTypes.includes(fileType)) {
          warningMessage("Please select a valid Excel file (.xlsx or .xls)");
          formik.setFieldValue("UploadFile", "");
          formik.setFieldValue(
            "UploadFileKey",
            Math.random().toString(9).substring(2, 9),
          );
        } else {
          formik.setFieldValue("UploadFile", file);
        }
      }
    } else {
      warningMessage("Select Master");
      formik.setFieldValue("UploadFile", "");
      formik.setFieldValue(
        "UploadFileKey",
        Math.random().toString(9).substring(2, 9),
      );
    }
  };

  const handleChangeMaster = (e) => {
    formik.setFieldValue("MasterID", e?.value ?? "");
    formik.setFieldValue("MasterFileFormatPath", e?.MasterFileFormatPath ?? "");
    formik.setFieldValue("MasterName", e?.label ?? "");
  };

  useEffect(() => {
    formik.setFieldValue("InValidRecords", 0);
    formik.setFieldValue("ValidCount", 0);
    formik.setFieldValue("TotalRecords", 0);
    formik.setFieldValue("InValidRecordsFilePath", "");
    formik.setFieldValue("ValidRecordsFilePath", "");
    formik.setFieldValue("ListOfMasterData", "");
    formik.setFieldValue("UploadFile", "");
    formik.setFieldValue(
      "UploadFileKey",
      Math.random().toString(9).substring(2, 9),
    );
  }, [MasterID]);

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">Import</h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Master Data"
                      name="MasterID"
                      placeholder={"Select Master"}
                      component={CustomSelect}
                      options={masterOptions}
                      required
                      onChange={handleChangeMaster}
                      autoFocus
                    />
                  </Col>
                  <Col lg={3}>
                    <div className="d-flex justify-content-between">
                      <label className="mb-1">
                        Upload File <span className="text-danger">*</span>
                      </label>
                    </div>

                    <input
                      type="file"
                      id="UploadFile"
                      accept=".xlsx, .xls"
                      className="form-control form-control-sm"
                      key={UploadFileKey || ""}
                      onChange={(e) => {
                        uploadUploadMasterFile(e);
                      }}
                    />
                    <ErrorMessage
                      name="UploadFile"
                      component="div"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    />
                  </Col>
                </Row>
                {MasterFileFormatPath ? (
                  <Row>
                    <div className="mt-1 mb-2">
                      <Link
                        to={MasterFileFormatPath}
                        className="text-primary"
                        style={{ fontSize: "13px" }}
                      >
                        {MasterName ? MasterName : ""} Download Format
                      </Link>
                    </div>
                  </Row>
                ) : (
                  <>
                    {MasterID ? (
                      <label style={{ color: "red" }}>
                        Formate not Found...!!
                      </label>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {UploadFile ? (
                  <Row>
                    <div className="d-flex">
                      <div style={{ width: "100%" }}>
                        <div className="bootstrap-badge pt-2">
                          <label
                            className="me-1 badge-success badge p-1"
                            style={{ color: "#ffffff", minWidth: "100px" }}
                          >
                            Total Records : {TotalRecords}
                          </label>
                          <label
                            className="me-1 badge-warning badge p-1"
                            style={{ color: "#ffffff", minWidth: "100px" }}
                          >
                            Valid Count : {ValidCount}
                          </label>
                          <label
                            className="me-1 badge-danger badge p-1"
                            style={{ color: "#ffffff", minWidth: "100px" }}
                          >
                            Invalid Records : {InValidRecords}
                          </label>
                          &nbsp; &nbsp;&nbsp;
                          {InValidRecords > 0 ? (
                            <label>
                              <Link
                                to={InValidRecordsFilePath}
                                className="text-primary"
                              >
                                Invalid Records File Download
                              </Link>
                            </label>
                          ) : (
                            ""
                          )}
                          &nbsp; &nbsp;&nbsp;
                          {ValidCount > 0 ? (
                            <label>
                              <Link
                                to={ValidRecordsFilePath}
                                className="text-primary"
                              >
                                Valid Records File Download
                              </Link>
                            </label>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </Row>
                ) : (
                  ""
                )}
                <Row>
                  <Col lg={12}>
                    {MasterID == 1 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Customer Name</th>
                                    <th>Short Name</th>
                                    <th>Email ID</th>
                                    <th>GST Registration Type</th>
                                    <th>GST No</th>
                                    <th>Customer In SEZ</th>
                                    <th>GST SEZ Type</th>
                                    {/* <th>Exemption From Date</th>
                                    <th>Exemption To Date</th> */}
                                    <th>Pan No</th>
                                    <th>Vendor Code</th>
                                    <th>IsTPI</th>
                                    <th>Opening Balance</th>
                                    <th>Opening Balance Date</th>
                                    <th>Proforma Invoice Required</th>
                                    <th>Credit Period</th>
                                    <th>Credit Limit</th>
                                    <th>Cash Only</th>
                                    <th>Credit Period Days</th>
                                    <th>Credit Limit Amount</th>
                                    <th>Project Name</th>
                                    <th>Project Country</th>
                                    <th>Project State</th>
                                    <th>Project City</th>
                                    <th>Project Pin Code</th>
                                    <th>Project Mobile No</th>
                                    <th>Project Billing</th>
                                    <th>Project Reporting</th>
                                    <th>Project Dispatch Report</th>
                                    <th>Project Dispatch Material</th>
                                    <th>Project Address Line 1</th>
                                    <th>Project Address Line 2</th>
                                    <th>Project Address Line 3</th>
                                    <th>Contact Persons Project Name</th>
                                    <th>Contact Person</th>
                                    <th>Contact Person Mobile No</th>
                                    <th>Contact Person Telephone No</th>
                                    <th>Contact Person Email</th>
                                    <th>Contact Person Designation</th>
                                    <th>Contact Person Billing</th>
                                    <th>Contact Person Reporting</th>
                                    <th>Contact Person Dispatch</th>
                                    <th>Contact Person Dispatch Material</th>
                                    <th style={{ textAlign: "left" }}>
                                      Contact Person Stamp WriteUp
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>{item.ErrorMessage}</td>
                                        <td>{item.CustomerName}</td>
                                        <td>{item.ShortName}</td>
                                        <td>{item.EmailID}</td>
                                        <td>{item.GSTRegistrationType}</td>
                                        <td>{item.GSTNo}</td>
                                        <td>{item.CustomerInSEZ}</td>
                                        <td>{item.GSTSEZType}</td>
                                        {/* <td>
                                          {item?.ExemptionFromDate
                                            ? item?.ExemptionFromDate.split(
                                                " "
                                              )[0]
                                            : ""}
                                        </td>
                                        <td>
                                          {item?.ExemptionToDate
                                            ? item?.ExemptionToDate.split(
                                                " "
                                              )[0]
                                            : ""}
                                        </td> */}
                                        <td>{item.PanNo}</td>
                                        <td>{item.VendorCode}</td>
                                        <td>{item.IsTPI}</td>
                                        <td>{item.OpeningBalance}</td>
                                        <td>
                                          {item?.OpeningBalanceDate
                                            ? item?.OpeningBalanceDate.split(
                                                " ",
                                              )[0]
                                            : ""}
                                        </td>
                                        <td>{item.PerformaInvoiceRequired}</td>
                                        <td>{item.DefaultCreditPeriodDays}</td>
                                        <td>{item.SecurityCreditLimitRs}</td>
                                        <td>{item.CashOnly}</td>
                                        <td>
                                          {item.DefaultCreditPeriodDaysValue}
                                        </td>
                                        <td>
                                          {item.SecurityCreditLimitRsValue}
                                        </td>
                                        <td>{item.ProjectName}</td>
                                        <td>{item.ProjectCountry}</td>
                                        <td>{item.ProjectState}</td>
                                        <td>{item.ProjectCity}</td>
                                        <td>{item.ProjectPinCode}</td>
                                        <td>{item.ProjectMobileNo}</td>
                                        <td>{item.ProjectBilling}</td>
                                        <td>{item.ProjectReporting}</td>
                                        <td>{item.ProjectDispatchReport}</td>
                                        <td>{item.ProjectDispatchMaterial}</td>
                                        <td>{item.ProjectAddress}</td>
                                        <td>{item.ProjectAddressLine2}</td>
                                        <td>{item.ProjectAddressLine3}</td>
                                        <td>
                                          {item.ContactPersonsProjectName}
                                        </td>
                                        <td>{item.ContactPerson}</td>
                                        <td>{item.ContactPersonMobileNo}</td>
                                        <td>{item.ContactPersonTelephoneNo}</td>
                                        <td>{item.ContactPersonEmail}</td>
                                        <td>{item.ContactPersonDesignation}</td>
                                        <td>{item.ContactPersonBilling}</td>
                                        <td>{item.ContactPersonReporting}</td>
                                        <td>{item.ContactPersonDispatch}</td>
                                        <td>
                                          {item.ContactPersonDispatchMaterial}
                                        </td>
                                        <td style={{ textAlign: "left" }}>
                                          {item.ContactPersonStampWriteUp}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={46}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : MasterID == 3 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Material Group Name</th>
                                    <th>Material Types</th>
                                    <th style={{ textAlign: "left" }}>
                                      Departments
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>{item.ErrorMessage}</td>
                                        <td>{item.MaterialGroupName}</td>
                                        <td>{item.MaterialTypes}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.Departments}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={10}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : MasterID == 4 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Test Method Name</th>
                                    <th>Description</th>
                                    <th>NABL</th>
                                    <th>Display Name</th>
                                    <th>Nick Name</th>
                                    <th style={{ textAlign: "left" }}>
                                      Verification Date
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>{item.ErrorMessage}</td>
                                        <td>{item.TestMethodName}</td>
                                        <td>{item.Description}</td>
                                        <td>{item.NABL}</td>
                                        <td>{item.DisplayName}</td>
                                        <td>{item.NickName}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.VerificationDate
                                            ? item.VerificationDate.split(
                                                " ",
                                              )[0]
                                            : ""}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={8}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : MasterID == 5 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Parameter Name</th>
                                    <th>NABL</th>
                                    <th>Parameter Result Type</th>
                                    <th>Department</th>
                                    <th>Material Group</th>
                                    {/* <th>Material Group</th>
                                    <th>Material Type</th> */}
                                    <th>Test Method</th>
                                    <th>Range From</th>
                                    <th>Range To</th>
                                    <th style={{ textAlign: "left" }}>Unit</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>{item.ErrorMessage}</td>
                                        <td>{item.ParameterName}</td>
                                        <td>{item.NABL}</td>
                                        <td>{item.ParameterResultType}</td>
                                        <td>{item.Departments}</td>
                                        <td>{item.MaterialGroup}</td>
                                        {/* <td>{item.MaterialGroup}</td>
                                        <td>{item.MaterialType}</td> */}
                                        <td>{item.TestMethod}</td>
                                        <td>{item.RangeFrom}</td>
                                        <td>{item?.RangeTo}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.Unit}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={12}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : MasterID == 6 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Test Name</th>
                                    <th>Department</th>
                                    <th>Material Group</th>
                                    {/* <th>Test Group</th> */}
                                    <th>NABL</th>
                                    <th>Display Name</th>
                                    <th>Parameter Header Display Name</th>
                                    <th>Default Test Count</th>
                                    <th>Sample Minimum Qty</th>
                                    <th>Sample Qty Unit</th>
                                    <th>Machining Required</th>
                                    {/* <th>Material Types</th>
                                    <th>Test Methods</th> */}
                                    <th>Machines</th>
                                    <th style={{ textAlign: "left" }}>
                                      Images
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>{item.ErrorMessage}</td>
                                        <td>{item.TestName}</td>
                                        <td>{item.Department}</td>
                                        <td>{item.MaterialGroup}</td>
                                        {/* <td>{item.TestGroup}</td> */}
                                        <td>{item.NABL}</td>
                                        <td>{item.DisplayName}</td>
                                        <td>
                                          {item.ParameterHeaderDisplayName}
                                        </td>
                                        <td>{item.DefaultTestCount}</td>
                                        <td>{item.SampleMinimumQty}</td>
                                        <td>{item.SampleQtyUnit}</td>
                                        <td>{item.MachiningRequired}</td>
                                        {/* <td>{item.MaterialTypes}</td>
                                        <td>{item.TestMethods}</td> */}
                                        <td>{item.Machines}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.Images}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={17}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : MasterID == 7 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Department</th>
                                    <th>Test Name</th>
                                    <th>Parameter Name</th>
                                    <th>Display Sequence</th>
                                    <th>Display Name</th>
                                    <th>Requirement</th>
                                    <th>Default Value</th>
                                    <th>Additional Charge</th>
                                    <th style={{ textAlign: "left" }}>
                                      Printable
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>
                                          {item?.ErrorMessage?.split(",")
                                            ?.filter((msg) => msg.trim() !== "")
                                            ?.map((msg, index) => (
                                              <React.Fragment key={index}>
                                                {msg.trim()}
                                                <br />
                                              </React.Fragment>
                                            ))}
                                        </td>
                                        <td>{item.Department}</td>
                                        <td>{item.TestName}</td>
                                        <td>{item.ParameterName}</td>
                                        <td>{item.DisplaySequence}</td>
                                        <td>{item.DisplayName}</td>
                                        <td>{item.Requirement}</td>
                                        <td>{item.DefaultValue}</td>
                                        <td>{item?.AdditionalCharge}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.Printable}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={12}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : MasterID == 8 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Department</th>
                                    <th>Test Name</th>
                                    <th>Parameter Name</th>
                                    <th>Display Sequence</th>
                                    <th>Display Name</th>
                                    <th>Display Code</th>
                                    <th>Requirement</th>
                                    <th>Default Value</th>
                                    <th>Additional Charge</th>
                                    <th style={{ textAlign: "left" }}>
                                      Printable
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>
                                          {item?.ErrorMessage?.split(",")
                                            ?.filter((msg) => msg.trim() !== "")
                                            ?.map((msg, index) => (
                                              <React.Fragment key={index}>
                                                {msg.trim()}
                                                <br />
                                              </React.Fragment>
                                            ))}
                                        </td>
                                        <td>{item.Department}</td>
                                        <td>{item.TestName}</td>
                                        <td>{item.ParameterName}</td>
                                        <td>{item.DisplaySequence}</td>
                                        <td>{item.DisplayName}</td>
                                        <td>{item.DisplayCode}</td>
                                        <td>{item.Requirement}</td>
                                        <td>{item.DefaultValue}</td>
                                        <td>{item?.AdditionalCharge}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.Printable}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={12}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : MasterID == 9 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Reference Standard Name</th>
                                    <th>Department</th>
                                    <th>Material Group</th>
                                    <th style={{ textAlign: "left" }}>
                                      Description
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>{item.ErrorMessage}</td>
                                        <td>{item.ReferenceStandardName}</td>
                                        <td>{item.Department}</td>
                                        <td>{item.MaterialGroup}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.Description}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={6}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : MasterID == 11 ? (
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <div className="d-flex  mb-1"></div>
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="MasterImport-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="MasterImport-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th>Sr No</th>
                                    <th>Error Message</th>
                                    <th>Machine Name</th>
                                    <th>Manufacturing Company</th>
                                    <th>Serial No</th>
                                    <th>Machine Number</th>
                                    <th>Calibration Validity in Months</th>
                                    <th>Machine Range</th>
                                    <th>Remarks</th>
                                    <th>Machine Parameters</th>
                                    <th style={{ textAlign: "left" }}>
                                      Machine Group
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfMasterData?.length > 0 ? (
                                    ListOfMasterData?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          backgroundColor:
                                            item?.IsValid == false
                                              ? "#ffdede"
                                              : "#e1eae1",
                                        }}
                                      >
                                        <td>{item.SRNo}</td>
                                        <td>{item.ErrorMessage}</td>
                                        <td>{item.MachineName}</td>
                                        <td>{item.ManufacturingCompany}</td>
                                        <td>{item.SerialNo}</td>
                                        <td>{item.MachineNumber}</td>
                                        <td>
                                          {item.CalibrationValidityinMonths}
                                        </td>
                                        <td>{item.MachineRange}</td>
                                        <td>{item.Remarks}</td>
                                        <td>{item?.MachineParameters}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.MachineGroup}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={12}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <div className="stickyBottomButtons">
                  <hr className="mt-1 mb-2"></hr>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("btnSubmitType", 1);
                    }}
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Validate
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("btnSubmitType", 2);
                    }}
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default MasterDataImport;
